import React, { useMemo, useState } from "react";
import AreaChart from "../charts/AreaChart";
import { cn } from "../../utils/cn";
import { useGetTotalVisitorsCountByDate } from "../../hooks/dashboard/query";
import {
  formattedDate,
  getDateOneMonthAgo,
  getDateOneWeekAgo,
} from "../../lib/functions";
import Loader from "../loader";
import { useTranslation } from "react-i18next";

function formatVisitorsData(input: any) {
  return input?.map((item: any) => ({
    date: new Date(item.visitDate).toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
    }),
    value: item.visitorsCount,
  }));
}

const TotalVisitorsCard = () => {
  const { t } = useTranslation();

  const [isWeeklySelected, setIsWeeklySelected] = useState(true);

  const frequencyOptions = useMemo(
    () => [
      { id: 1, label: t("weekly"), value: "Weekly" },
      { id: 2, label: t("monthly"), value: "Monthly" },
    ],
    [t]
  );

  const { data: totalVisitorsCounts, isPending: isTotalVisitorsCountsLoading } =
    useGetTotalVisitorsCountByDate({
      fromDate: isWeeklySelected ? getDateOneWeekAgo() : getDateOneMonthAgo(),
      toDate: formattedDate(new Date()),
    });

  return (
    <div className="bg-white rounded-[15px] px-5 py-4 xl:p-5 flex flex-col gap-7 w-full xl:w-[50%]">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 sm:gap-0">
        <h1 className="text-xl">{t("totalVisitors")}</h1>

        <div className="flex items-center gap-4 sm:mr-6">
          {frequencyOptions.map((item) => (
            <div
              key={item.id}
              className={cn("flex items-center gap-1.5 cursor-pointer")}
              onClick={() => setIsWeeklySelected(item.id === 1)}
            >
              <div
                className={cn(
                  "w-3 h-3 rounded-full",
                  item.id === 1 && isWeeklySelected
                    ? "bg-purple-primary"
                    : item.id === 2 && !isWeeklySelected
                    ? "bg-purple-primary"
                    : "ring-1 ring-purple-primary"
                )}
              />
              <p className="text-sm">{item.label}</p>
            </div>
          ))}
        </div>
      </div>

      {isTotalVisitorsCountsLoading ? (
        <div className="flex justify-center">
          <Loader />
        </div>
      ) : (
        <AreaChart data={formatVisitorsData(totalVisitorsCounts)} />
      )}
    </div>
  );
};

export default React.memo(TotalVisitorsCard);
